import "./ContactUs.module.css";
import Header from "@/reusable_sections/Header";
import ContactPageTitle from "./sections/ContactPageTitle";
import ContactFormAndDetails from "./sections/ContactFormAndDetails";
import ServiceLocations from "./sections/ServiceLocations";
import Footer from "@/reusable_sections/Footer";
export default function ContactUsPage() {
  return <div>
      <Header />
      <ContactPageTitle />
      <ContactFormAndDetails />
      <ServiceLocations />
      <Footer />
    </div>;
}